<template>
  <slot name="activator" :open="open"></slot>
  <Teleport :to="rootElement">
    <transition name="fade">
      <sel-backdrop
        :class="bemClass('overlay')"
        :modifier="modifier"
        :is-active="isActive"
        @click="close"
      />
    </transition>
    <transition name="fade">
      <div :class="bemClass()" v-bind="$attrs" v-if="isActive">
        <sel-button :class="bemClass('close')" @click.prevent="close">
          <slot name="close-icon">
            <sel-icon icon-name="icon-close"></sel-icon>
          </slot>
        </sel-button>
        <div :class="bemClass('content')" ref="el">
          <slot></slot>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import activator from '../../compositions/activator'
import useBem from '../../compositions/bem'
import SelBackdrop from '../sel-backdrop/sel-backdrop'
import { ref, toRefs } from 'vue'
import useBodyLockScroll from '../../compositions/body-scroll-lock'

export default {
  name: 'SelDialog',
  components: { SelBackdrop },
  inheritAttrs: false,
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    activatorSelector: {
      type: String
    },
    className: {
      type: String,
      default: ''
    },
    rootElement: {
      type: [String, Object],
      default: '#dialog-target'
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { modifier, isActive } = toRefs(props)
    const { bemClass } = useBem('sel-dialog', modifier)
    const el = ref(null)

    useBodyLockScroll(el, isActive)

    return {
      el,
      bemClass,
      ...activator(props, { emit })
    }
  }
}
</script>

<style scoped>
.sel-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  max-width: 600px;
  height: auto;
  min-height: 300px;
  z-index: 2;
  background-color: white;
  transform: translate3d(-50%, -50%, 0);
  border: 1px solid #000000;
}

.sel-dialog__close {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
}

.sel-dialog__content {
  padding: 20px;
  overflow-y: auto;
}
</style>
